import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23",
  fill: "none",
  viewBox: "0 0 23 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#86A315",
      d: "m6.778 9.625-1.972 1.887a4.037 4.037 0 0 0-1.263 2.917c0 1.094.454 2.143 1.263 2.917a4.415 4.415 0 0 0 3.05 1.208c1.144 0 2.24-.435 3.05-1.208l2.627-2.515a4.096 4.096 0 0 0 1.06-1.667 3.953 3.953 0 0 0 .141-1.947 4.036 4.036 0 0 0-.81-1.79 4.279 4.279 0 0 0-1.581-1.235l-.842.806c-.086.082-.16.174-.222.274.481.132.918.382 1.267.725.348.343.598.767.723 1.23.125.464.121.95-.01 1.412a2.725 2.725 0 0 1-.742 1.221L9.89 16.374a2.944 2.944 0 0 1-2.034.806c-.763 0-1.495-.29-2.035-.806a2.692 2.692 0 0 1-.842-1.946c0-.73.303-1.43.842-1.946l1.14-1.089a5.263 5.263 0 0 1-.184-1.768Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#86A315",
      d: "M9.468 7.054a4.097 4.097 0 0 0-1.06 1.667 3.953 3.953 0 0 0-.14 1.947c.116.65.394 1.264.81 1.79.416.527.958.95 1.58 1.234l1.114-1.067a2.907 2.907 0 0 1-1.288-.712 2.724 2.724 0 0 1-.744-1.232 2.634 2.634 0 0 1 0-1.424c.13-.466.387-.891.744-1.232l2.627-2.514a2.944 2.944 0 0 1 2.034-.806c.763 0 1.494.29 2.034.806.54.516.842 1.216.842 1.946s-.303 1.43-.842 1.945l-1.14 1.09c.16.577.223 1.175.184 1.769l1.972-1.887a4.036 4.036 0 0 0 1.263-2.917 4.037 4.037 0 0 0-1.263-2.917 4.414 4.414 0 0 0-3.05-1.208c-1.143 0-2.24.435-3.05 1.208L9.469 7.054Z"
    }, null, -1)
  ]))]))
}
export default { render: render }